require('../../../custom-components/flex-spot/index');